import { Divider, Group, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setRelatedTasksSelectedInitiative } from '../../../../../store/strategy-store/strategy-store.actions';
import { inkLight, secondaryBase } from '../../../../../styles/design-tokens';
import { Radio } from '../../../../../ui-library/radio/radio';
import { Text } from '../../../../../ui-library/typography/typography';
import { useContributingInitiatives } from '../../initiative-performance.hooks';

export const FiltersInitiatives = () => {
  const i18n = useTranslation();
  const contributingInitiatives = useContributingInitiatives();
  const selectedInitiative = useRelatedTasksTabStore((state) => state.selectedInitiative);
  return (
    <Stack>
      {contributingInitiatives.length > 0 && (
        <>
          <Group justify="space-between">
            <Radio
              key="all-initiatives"
              label={<Text size="small">{`All ${i18n.t('strategy.tabs.initiatives')}`}</Text>}
              checked={selectedInitiative === null}
              onChange={() => setRelatedTasksSelectedInitiative(null)}
            />
            <Text size="small" color={inkLight}>
              {contributingInitiatives.length}
            </Text>
          </Group>
          <Divider />
        </>
      )}
      <Stack gap={24}>
        {contributingInitiatives.map((initiative) => (
          <Stack gap={8} key={initiative.id}>
            <Group justify="space-between">
              <Radio
                label={
                  <Text size="small" color={secondaryBase} style={{ lineHeight: '20px' }}>
                    {initiative.key}
                  </Text>
                }
                checked={initiative.id === selectedInitiative}
                onChange={() => setRelatedTasksSelectedInitiative(initiative.id)}
              />
              <Text size="small" color={inkLight}>
                {`${initiative.epic_count} ${i18n.t('common.parent_task').toLowerCase()}${initiative.epic_count === 1 ? '' : 's'}`}
              </Text>
            </Group>
            <Text size="small">{initiative.name}</Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
